import { createFileRoute } from '@tanstack/react-router'
import ConversasPage from '@/pages/conversas/conversas-page'
import { useUserCapabilities } from '@/hooks/use-user-capabilities'
import { UnauthorizedPage } from '@/components/auth/UnauthorizedPage'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

// Rota index para /dashboard/$dashboardId/conversas
// Renderizada quando acessar diretamente /dashboard/$dashboardId/conversas
export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/conversas/',
)({
  component: function ConversasRoute() {
    const { dashboardId } = Route.useParams()
    const { canAccessConversas, isLoading } = useUserCapabilities(dashboardId)

    if (isLoading) {
      return (
        <div className="flex items-center justify-center min-h-[calc(100vh-200px)]">
          <div className="text-muted-foreground">Carregando...</div>
        </div>
      )
    }

    if (!canAccessConversas()) {
      return <UnauthorizedPage />
    }

    return (
      <RequireModule module={MODULES.CONVERSATIONS} dashboardId={dashboardId}>
        <ConversasPage dashboardId={dashboardId} />
      </RequireModule>
    )
  },
})
